module.exports = __webpack_public_path__ + "static/panna@-189818ff2bc0f50b76186f27b8023c01.png";